var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"date-input",attrs:{"type":"text"},domProps:{"value":_vm.dateText},on:{"input":_vm.handleTextInput,"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }